import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js';
import BasePropertyView from 'BasePropertyView.js';
import labelTemplate from 'properties/main/label.ejs';


class MainLabelView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = labelTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'toggleVisibility',
            'change input[type=text]':'updateLabelText',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        // Add needed property
        if (!this.model.get('label')) {
            this.model.set('label', '', {silent: true});
        }
        if (this.model.get('showLabel') === undefined) {
            this.model.set('showLabel', true, {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    toggleVisibility(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.target.checked;

        this.model.set( propName, propVal );
    }

    updateLabelText(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set(propName,propVal);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bShowLabel = util.isTrue(this.model.get('showLabel'));
        $(`input[name='showLabel']`).prop('checked', bShowLabel );
        
        this.delegateEvents();
        return this;
    }

}

export default MainLabelView;
